<template>
  <div class="css-tr">
    <div class="css-th align right w-f6">
      <b class="notice">*</b>
      {{ prefix }}
    </div>
    <div class="css-td">
      <input
        v-if="isNotMasked"
        v-model="name"
        v-validate="validateRule"
        :name="errMsg"
        class="input-lg"
        maxlength="7"
        autocomplete="off"
        type="text" />
      <input v-else v-model="maskedName" class="input-lg" type="text" @focus="isNotMasked = true" />
      <span class="sub spacing">{{ postfix }}</span>
      <slot></slot>
      <p class="error">{{ errors.first(errMsg) }}</p>
    </div>
  </div>
</template>

<script>
import { compose, prop } from 'ramda';
import { createAdvComputed } from '@/helpers/vuex';
import { useMask } from '@/composables/mask';
import { index } from '@/components/desktop/step1/common/constant/common-name.constant';

/** [收件人] 即時輸入有資料 */
const name = compose(createAdvComputed, prop('name'))(index);

export default {
  name: 'common-name',
  props: {
    /** 與 Vuex 綁定的 module 名稱 */
    module: {
      type: String,
      default: '',
    },
    /** 與 Vuex 綁定的 state 名稱 */
    states: {
      type: Array,
      default() {
        return [];
      },
    },
    /** 前面所顯示的字串 */
    prefix: {
      type: String,
      default: '',
    },
    /** 後面所顯示的字串 */
    postfix: {
      type: String,
      default: '',
    },
    /** 錯誤訊息 */
    errMsg: {
      type: String,
      default: '',
    },
    validateRule: {
      type: String,
      default: 'required',
    },
  },
  computed: {
    name,
  },
  created() {
    this.setIsNotMaskedByValue(this.name);
  },
  setup(props) {
    const { maskedName, isNotMasked, setIsNotMaskedByValue } = useMask(props);
    return { maskedName, isNotMasked, setIsNotMaskedByValue };
  },
};
</script>
